import { render, staticRenderFns } from "./SelectorInput.vue?vue&type=template&id=5142ca45&scoped=true&"
import script from "./SelectorInput.vue?vue&type=script&lang=ts&"
export * from "./SelectorInput.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorInput.vue?vue&type=style&index=0&id=5142ca45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142ca45",
  null
  
)

export default component.exports